"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Icon;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _getWindow = _interopRequireDefault(require("../utils/get-window"));

var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Display an Assembly icon.
 *
 * Besides providing a convenient shortcut, this component does the following:
 *
 * - Sets some accessibility props.
 * - Provides an `inline` mode that automatically sizes icons to match their
 *   surrounding text.
 */
function Icon(_ref) {
  var name = _ref.name,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      _ref$passthroughProps = _ref.passthroughProps,
      passthroughProps = _ref$passthroughProps === void 0 ? {} : _ref$passthroughProps,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 18 : _ref$size;
  var el = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (inline && el.current) {
      var lineHeight = (0, _getWindow.default)().getComputedStyle(el.current)['line-height'];
      el.current.style.height = lineHeight;
    }
  }, [inline, size]);
  var iconClasses = 'events-none icon';

  if (inline) {
    iconClasses += ' inline-block align-t';
  }

  var svgStyle = passthroughProps.style || {};

  if (!svgStyle.width && size) {
    svgStyle.width = size;
  }

  if (!svgStyle.height && size) {
    svgStyle.height = size;
  }

  return /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: name
  }, /*#__PURE__*/_react.default.createElement("svg", _extends({
    ref: el,
    className: iconClasses,
    "data-testid": "icon-".concat(name)
  }, passthroughProps, {
    style: svgStyle
  }), /*#__PURE__*/_react.default.createElement("use", {
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#icon-".concat(name)
  })));
}

Icon.propTypes = {
  /**
   * The name of the [Assembly icon](https://labs.mapbox.com/assembly/icons/) that
   * you want to display.
   */
  name: _propTypes.default.string.isRequired,

  /**
   * The width and height of the icon. All icons fill up a square space,
   * so this value will be applied to both width and height.
   *
   * If `inline: true`, the technical height will be controlled by the
   * line-height of the container, but the appearance of the icon will still
   * be in accordance with your `size` value (because it's limited by the
   * width).
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * If `true`, the icon will be adjusted after mounting so that its height
   * matches the line-height of its container. The result of this is that
   * the icon will not displace the text's established line-height and
   * will be vertically centered with the text alongside it.
   *
   * This is most useful when you are inserting the icon within multiline text,
   * so you can't use a flexbox layout to vertically center the icon and text.
   *
   * Be aware that there are edge cases that can cause problems with this
   * setting. For example, it won't work well if you don't have a `line-height`
   * set to a pixel value, or if there are dynamic adjustments to the
   * line-height.
   */
  inline: _propTypes.default.bool,

  /**
   * Props to pass directly to the `<svg>` element.
   */
  passthroughProps: _propTypes.default.object
};